import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "Which tools are commonly used in graphic designing?",
    category: "Technology",
    description:
      "Graphic designers use tools like Adobe Photoshop, Illustrator, InDesign, Figma, Canva, and CorelDRAW. These tools help create logos, posters, UI layouts, illustrations, and professional design assets for digital and print media.",
  },
  {
    title: "What industries hire graphic designers?",
    category: "Trending",
    description:
      "Industries like advertising, marketing, media, e-commerce, IT, education, fashion, entertainment, and publishing actively hire graphic designers for branding, content creation, and digital marketing campaigns.",
  },
  {
    title: "How important is a portfolio for graphic designers?",
    category: "Design",
    description:
      "A portfolio is essential because it showcases your style, skills, and real projects. It helps employers understand your design approach and creativity better than a resume alone.",
  },
  {
    title: "What types of projects do graphic designers work on?",
    category: "Design",
    description:
      "Designers work on logos, posters, banners, packaging, brochures, social media content, website graphics, marketing materials, and brand identity systems for various digital and print platforms.",
  },
  {
    title: "What skills are essential for a graphic designer?",
    category: "Design",
    description:
      "Key skills include creativity, typography, color theory, layout design, branding understanding, and software proficiency. Problem-solving, visual thinking, and attention to detail are equally important for producing polished and effective designs.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
